import { render, staticRenderFns } from "./REPreviousList.vue?vue&type=template&id=7040fb2d&"
import script from "./REPreviousList.vue?vue&type=script&lang=js&"
export * from "./REPreviousList.vue?vue&type=script&lang=js&"
import style0 from "./REPreviousList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports